import {QRCodeSVG} from "qrcode.react";
import AppConfig from "../../AppConfig";
import {CCText, View} from "../react-native-components-in-react/react-native-components-in-react";
import {ThemeButton} from "../react-button-package/ButtonPackage";
import TMenuItem from "../../components/admin/Menu/Translations/TMenuItem";
import React, {useRef} from "react";
import domtoimage from "dom-to-image";
import {useSelector} from "react-redux";
import {RegisterEvent} from "../../AnalyticsFunctions";

const TQRCodeWrapper = {
    "enUS": {
        DOWNLOAD: 'Download',
    },
    "esMX": {
        DOWNLOAD: 'Descargar',
    }
}

const gtag_download_qr_conversion = (url) => {
    var callback = function () {
        if (typeof(url) !== 'undefined') {
            window.location = url;
        }
    };

    window.gtag('event', 'conversion', {
        'send_to': 'AW-850564176/RzRoCKGhhJIZENCoypUD',
        'event_callback': callback
    });

    return false;
}

const QRCodeWrapper = ({ url, logo, showDownloadButton }) => {
    const auth = useSelector(state => state.Auth);
    const qrCodeRef = useRef();

    const downloadQRCode = async () => {
        const dataUrl = await domtoimage.toPng(qrCodeRef.current, {
            backgroundColor: 'transparent',
        });
        const downloadLink = document.createElement('a');
        downloadLink.href = dataUrl;
        downloadLink.download = 'menu.png';
        downloadLink.click();

        gtag_download_qr_conversion()


        RegisterEvent({
            source: window.location.href,
            sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
            token: auth.token,
            action: 'DOWNLOAD_QR_CODE'
        })
    }


    return <View style={{ justifyContent: 'center', alignItems: 'center' }}>
        <div
            ref={qrCodeRef}
            style={{
                padding: 20,
            }}
        >
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                width: 230,
                height: 230
            }}>
                <QRCodeSVG
                    value={url}
                    size={230}
                    imageSettings={logo ? {
                        src: '',
                        width: 60,
                        height: 60,
                        excavate: true
                    } : null}
                />
                {
                    logo ?
                        <img src={logo} width={60} height={60} style={{ position: 'absolute' }} />
                        :
                        null
                }
            </div>
            {auth.sub && (
                auth.sub.code === AppConfig.SUB_BASIC
                ||
                auth.sub.code === AppConfig.SUB_STANDARD
                ||
                auth.sub.code === AppConfig.SUB_PREMIUM
            ) ?
                null
                :
                <CCText className="special-title" style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 28, margin: 10 }}>
                    www.Tastee.app
                </CCText>
            }
        </div>
        {
            showDownloadButton ?
                <ThemeButton
                    style={{ marginTop: 10 }}
                    text={TQRCodeWrapper[AppConfig.lang].DOWNLOAD}
                    onPress={downloadQRCode}
                />
                :
                null
        }
    </View>
}

export default QRCodeWrapper;